<template>
  <div id="app">
    <AGWAudio :file="music.file" :loop="music.loop" :autoplay="music.autoplay" />
    <AGWHero overlay :background="backgrounds" ref="hero" parallax target="#intro" />

    <div class="agw-content bg-white" :style="{ 'margin-top' : `${$root.hero.height}px` }">
      <AGWIntro id="intro" />

      <div class="pad-y-60">
        <AGWPawiwahan id="pawiwahan" />
        <AGWMepandes id="mepandes" class="mar-top-60" :mepandes="mepandes" />
      </div>

      <AGWCounter id="counter" class="pad-y-60" :background="background" :date="time.start" />
      <AGWGallery id="gallery" class="pad-y-60" />
      <AGWMap
        :height="450"
        url="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6500.601849158086!2d115.18697923874416!3d-8.670624778522786!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zOMKwNDAnMTguMiJTIDExNcKwMTEnMjEuMiJF!5e0!3m2!1sen!2sid!4v1595032829049!5m2!1sen!2sid"
        directionUrl="https://www.google.com/maps/dir//-8.6717281,115.1892166/@-8.6706248,115.1869792,16.28z/data=!4m2!4m1!3e0?hl=en"
        :location="location"
        :time="time"
        id="map"
      />
    </div>

    <div class="agw-content" style="background: transparent">
      <attendance id="attendance" class="pad-y-60"></attendance>
    </div>

    <div :style="{ 'height' : `${$root.dividerHeight}px` }"></div>

    <section class="footer bg-white pad-y-20" ref="footer">
      <div class="font-weight-lighter">
        &copy; {{ $moment().format('YYYY') }}. Made by
        <a href="https://ceremonyku.com">ceremonyku</a>.
      </div>
    </section>

    <transition name="slide-fade">
      <guest-box :floating="true" v-if="$root.scroll.Y > $root.hero.height" />
    </transition>

    <div class="snackbar" v-if="sw.updateExists">
      New version available!
      <button @click="refreshApp" class="btn">REFRESH</button>
    </div>
  </div>
</template>

<script>
const ImageHero1 =
  'https://ik.imagekit.io/aryraditya/ceremonyku/yudha-dewi/IMG_3879_KQfw-cnQXq_.jpg?tr=w-1024';
const ImageHero2 =
  'https://ik.imagekit.io/aryraditya/ceremonyku/yudha-dewi/IMG_3420_Svx0MxyXNc.jpg?tr=w-1024';
const ImageHero3 =
  'https://ik.imagekit.io/aryraditya/ceremonyku/yudha-dewi/IMG_3397_2rUK8UMU8T.jpg?tr=w-1024';

import Audio from '@/assets/audio/beautiful-in-white.mp3';

import AGWHero from '@/components/Hero';
import AGWIntro from '@/components/Intro';
import AGWPawiwahan from '@/components/Pawiwahan';
import AGWMepandes from '@/components/Mepandes';
import AGWCounter from '@/components/Counter';
import AGWGallery from '@/components/Gallery';
import AGWMap from '@/components/Maps';
import AGWAudio from '@/components/Audio';
import GuestBox from '@/components/GuestBox';
import Attendance from '@/components/Attendance';

import { setInterval } from 'timers';

export default {
  name: 'app',
  components: {
    AGWHero,
    AGWIntro,
    AGWPawiwahan,
    AGWMepandes,
    AGWCounter,
    AGWGallery,
    AGWMap,
    AGWAudio,
    GuestBox,
    Attendance
  },
  data() {
    return {
      title: 'Pernikahan',
      backgrounds: [ImageHero1, ImageHero2, ImageHero3],
      bgActive: 0,
      dividerHeight: 0,
      wedding: {
        man: {
          name: 'Yudhi Perdana Saputra, S.E',
          surname: 'Yudhi',
          parents: 'Hendra Prayitio Saputra (Tio Hok Sun) & Ni Made Korni Lestari',
          description: 'Putra pertama',
          address:
            'Jl. Gunung Talang 2A No. A7 Perum Buana Indah Garden, Padang Sambian',
          photo:
            'https://ik.imagekit.io/aryraditya/ceremonyku/yudha-dewi/crop_FHFJm9tO4.jpg?tr=w-400'
        },
        woman: {
          name: 'Luh Ketut Swandewi',
          surname: 'Dewi',
          parents: 'Jr. Gede Made Warsa (almarhum) & Nengah Widiani',
          address: 'Jl. Nuansa Bukit Blok XIIA No. 17',
          description: 'Putri kelima',
          photo:
            'https://ik.imagekit.io/aryraditya/ceremonyku/yudha-dewi/IMG_3779_XVpi94PuW5.jpg?tr=w-400'
        }
      },
      location:
        'Jl. Gunung Talang 2A No. A7 Perum Buana Indah Garden, Padang Sambian',
      time: {
        start: this.$moment('2020-08-03 07:00'),
        end: 'Selesai'
      },
      mepandes: [],
      music: {
        file: Audio,
        autoplay: true,
        loop: true
      },
      sw: {
        refreshing: false,
        registration: null,
        updateExists: false
      }
    };
  },
  computed: {
    background() {
      return this.backgrounds[this.bgActive];
    }
  },
  mounted() {
    this.dividerHeight = `calc(100vh - ${this.$refs.footer.offsetHeight}px)`;
    setInterval(() => {
      let active = this.bgActive + 1;
      if (active >= this.backgrounds.length) {
        active = 0;
      }

      this.bgActive = active;
    }, 5000);
  },
  created() {
    document.addEventListener('swUpdated', this.showRefreshUI, { once: true });
    // if(navigator.serviceWorker) {
    //   navigator.serviceWorker.addEventListener("controllerchange", () => {
    //   if (this.sw.refreshing) return;
    //   // this.sw.refreshing = true;
    //   // window.location.reload();
    // });
    // }
  },
  methods: {
    showRefreshUI(e) {
      this.sw.registration = e.detail;
      this.sw.updateExists = true;
    },
    refreshApp() {
      this.sw.updateExists = false;
      if (!this.sw.registration || !this.sw.registration.waiting) {
        return;
      }
      this.sw.registration.waiting.postMessage('skipWaiting');
      this.sw.refreshing = true;
      window.location.reload();
    }
  }
};
</script>
